/*
 * 判断obj是否为一个整数
 */
function isInteger(obj) {
  return Math.floor(obj) === obj
}

/*
 * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
 * @param floatNum {number} 小数
 * @return {object}
 *   {times:100, num: 314}
 */
function toInteger(floatNum) {
  var ret = { times: 1, num: 0 }
  if (isInteger(floatNum)) {
    ret.num = floatNum
    return ret
  }
  var strfi = floatNum + ''
  var dotPos = strfi.indexOf('.')
  var len = strfi.slice(dotPos + 1).length
  var times = Math.pow(10, len)
  var intNum = Number(floatNum.toString().replace('.', ''))
  ret.times = times
  ret.num = intNum
  return ret
}

/*
 *
 * @param {*} num
 * @param {*} digits
 * @returns
 */
function fixed(num, digits) {
  return +num.toFixed(digits)
}

/*
 *
 * @param {*} num
 * @returns
 */
function isNumber(num) {
  return typeof num === 'number' && !isNaN(num)
}

/*
 * 核心方法，实现加减乘除运算，确保不丢失精度
 * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
 *
 * @param a {number} 运算数1
 * @param b {number} 运算数2
 * @param digits {number} 精度，保留的小数点数，比如 2, 即保留为两位小数
 * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
 *
 */
function operation(a, b, digits = 2, op) {
  a = Number(a)
  b = Number(b)
  if (!isNumber(a) || !isNumber(b)) return 0
  var o1 = toInteger(a)
  var o2 = toInteger(b)
  var n1 = o1.num
  var n2 = o2.num
  var t1 = o1.times
  var t2 = o2.times
  var max = t1 > t2 ? t1 : t2
  var result = null
  switch (op) {
    case 'add':
      if (t1 === t2) {
        // 两个小数位数相同
        result = n1 + n2
      } else if (t1 > t2) {
        // o1 小数位 大于 o2
        result = n1 + n2 * (t1 / t2)
      } else {
        // o1 小数位 小于 o2
        result = n1 * (t2 / t1) + n2
      }
      // return result / max
      return fixed(result / max, digits)
    case 'subtract':
      if (t1 === t2) {
        result = n1 - n2
      } else if (t1 > t2) {
        result = n1 - n2 * (t1 / t2)
      } else {
        result = n1 * (t2 / t1) - n2
      }
      // return result / max
      return fixed(result / max, digits)
    case 'multiply':
      result = (n1 * n2) / (t1 * t2)
      // return result
      return fixed(result, digits)
    case 'divide':
      result = (n1 / n2) * (t2 / t1)
      // return result
      return fixed(result, digits)
  }
}

// 加减乘除的四个接口
function add(a, b, digits) {
  return operation(a, b, digits, 'add')
}
function subtract(a, b, digits) {
  return operation(a, b, digits, 'subtract')
}
function multiply(a, b, digits) {
  return operation(a, b, digits, 'multiply')
}
function divide(a, b, digits) {
  return operation(a, b, digits, 'divide')
}
function multiply100(a, digits = 0) {
  // 乘100结果要为整数
  return operation(a, 100, digits, 'multiply')
}
function divide100(a, digits) {
  return operation(a, 100, digits, 'divide')
}

export default {
  add: add,
  subtract: subtract,
  multiply: multiply,
  divide: divide,
  multiply100,
  divide100
}
